<template>
    <div id="contenedor-main-listado-solicitudes-obras">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop
              :listadoSolicitudesObras="listadoSolicitudesObras"
              :firma="firma">
            </desktop>
        </template>
        <template
            v-else>
            <!-- <mobile
              :listadoSolicitudesObras="listadoSolicitudesObras"
              :firma="firma">
            </mobile> -->
            <desktop
              :listadoSolicitudesObras="listadoSolicitudesObras"
              :firma="firma">
            </desktop>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoSolicitudesObras',
  props: {
    listadoSolicitudesObras: {
      type: Array,
      required: true,
    },
    firma: {
      type: Object,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
